<template>
    <div v-show="visible">
        <el-dialog title="修改评语" 
            element-loading-background = "rgba(255, 255,255,0.7)"
            :element-loading-text = "loadingText"
            v-loading="loading" 
            :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="650px">    
            <el-form ref="form" :model="form" label-width="80px">
                    <el-input
                        type="textarea"
                        placeholder="评语内容编写"
                        v-model="form.comment"
                        maxlength="1000"
                        rows="15"
                        show-word-limit>
                    </el-input>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <!-- <el-button type="danger" @click="save(1)">预览</el-button> -->
                <el-button type="primary" @click="save(2)">保存</el-button>
            </span> 
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../common/http';
    import {banBackSpace} from '../../../common/preventBackspace';// backspace退格

    export default {
        data(){
            return{
                visible: false,
                form:{
                    id:"",
                    comment:""
                },
                studencomprehensiveReport:{
                    title:"",
                    startDate:"",
                    endDate:""
                },
                loading:false,
                loadingText:"",
                operateType:"",
            }
        },
        created:function () {
        },
        mounted:function () {
            document.onkeypress = banBackSpace
            document.onkeydown = banBackSpace
        },
        methods:{
            init(studencomprehensiveReport,data,type){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.form.id=data.id;
                this.form.comment=data.comment;
                this.operateType=type;

                // 临时生成报告
                if(type == 1){
                    this.studencomprehensiveReport.title=studencomprehensiveReport.title;
                    this.studencomprehensiveReport.startDate=studencomprehensiveReport.startDate;
                    this.studencomprehensiveReport.endDate=studencomprehensiveReport.endDate;
                }
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            save(sign){
                 this.$refs['form'].validate((valid) => {
                    if(valid){
                        let url="";
                        // operateType:1-临时报告，2-正式报告
                        if(this.operateType == 1){
                            url= this.tempStudencomprehensiveReportUpdateUrl;
                        }else if(this.operateType == 2){
                            // url= this.studencomprehensiveReporsendNameUpdateUrl;
                        }

                        let data = {
                            id:this.form.id,
                            comment:this.form.comment,
                            type:sign,
                            title:this.studencomprehensiveReport.title,
                            startDate:this.studencomprehensiveReport.startDate,
                            endDate:this.studencomprehensiveReport.endDate
                        };
                        // console.log(JSON.stringify(data));
                        if(sign == 1){
                            this.loading=true;
                            this.loadingText="生成中...";
                        }else if(sign == 2){
                            this.loading=true;
                            this.loadingText="保存中...";
                        }

                        this.apiPost(url, data).then((res) => {
                            // console.log(JSON.stringify(res.data));
                            if(res.status === 200){
                                if(sign == 1){ //预览
                                    window.open(res.data);
                                }else if(sign == 2){
                                    this.$commonFn.showTip(res.message,1);
                                    this.visible=false;
                                    this.$parent.getData();
                                }
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                            this.loading=false;
                        }, (err) => {
                            console.log(err);
                            this.loading=false;
                        });
                    }
               });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/complexReport/UpdateComment.vue